import { Bounce, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Hàm tạo thông báo tùy chỉnh
const showToast = (type, message) => {
  const config = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    transition: Bounce,
    style: {
      backgroundColor: "#333",
      color: "#fff",
      borderRadius: "8px",
      padding: "10px",
    },
  };

  switch (type) {
    case "success":
      toast.success(message, config);
      break;
    case "error":
      toast.error(message, config);
      break;
    case "warning":
      toast.warning(message, config);
      break;
    case "info":
      toast.info(message, config);
      break;
    default:
      toast(message, config);
      break;
  }
};
export default showToast;
